import $ from 'jquery';
import {isPhone} from '../useragent';
import Watcher from '../watcher';
import StickyGarage from '../sticky-garage';
import type {Availability, CountryNames, Product, ReadyInStock, Variables} from '../product';
import {setCurrentCountry} from '../geocode';
import financing from '../financing';
import I18n from 'i18n-js';
import AutoplayVideo from '../video-autoplay';

const NO_ANIMATIONS = (globalThis as any).NO_ANIMATIONS;

const ITEMS: Array<V1.Product> = (globalThis as any).ITEMS;
const VARIABLES: Variables | null = (globalThis as any).VARIABLES;
const PRODUCT: Product = (globalThis as any).PRODUCT;
const COUNTRY_NAMES: CountryNames = (globalThis as any).COUNTRY_NAMES;
const AVAILABILITY: Availability = (globalThis as any).AVAILABILITY;
const READY_IN_STOCK: ReadyInStock = (globalThis as any).READY_IN_STOCK;

const $financing = $('.atc-c-container .financing, .price-container .financing'),
      FINANCING_HTML = $financing.map((index, el) => el.innerHTML);
(globalThis as any).financing = financing;

// Komponenten einbinden
import financingTable from '../parts/financing-table';
import ChooseOptions from '../components/Options/Choose.svelte';
const chooseOptions = new ChooseOptions({
    target: $('.choose-options')[0],
    props: {
        ITEMS, VARIABLES, COUNTRY_NAMES, AVAILABILITY, READY_IN_STOCK, PRODUCT,
        FEW_IN_STOCK: 10,
        payload: PRODUCT.payload,
        amount: PRODUCT.cart ? 1 : false,
    },
});
chooseOptions.$on('update', (e: CustomEvent) => {
    const {item, amount} = e.detail as {
        item: V1.Product | undefined,
        amount: number,
    };
    const index = ITEMS.indexOf(item);
    const $add_to_cart = $('.add-to-cart');
    $add_to_cart.attr('data-index', index);
    $add_to_cart.attr('data-amount', amount);
    $add_to_cart.trigger('update');

    const price = item ? item.unit_price * amount : undefined;
    financingTable.$set({price});
    const financingOffer = price && financing(price);
    if(financingOffer && !PRODUCT.nogo && PRODUCT.inquiry !== 'limited-edition') {
        const {monthlyText, rateText} = financingOffer;
        $financing.each((index, ele) => {
            $(ele).html(FINANCING_HTML[index]
                .replace('%{PRICE}', monthlyText)
                .replace('%{PERCENT}', rateText)
            ).show();
        });
    } else {
        $financing.hide();
    }
});
chooseOptions.$on('shipping', () => {
    const $size_table = $('#shipping-popup');
    $size_table.trigger('open');
});

if (isPhone) {
    // Produktdetails in mobil zum Aufklappen:
    $('#product_details > div').addClass('accordion-expand');

    const   $emailSampleBody = $('#email_sample_body'),
            $emailShippingeBody = $('#email_shipping_body'),
            SAMPLE_SUBJECT = $('#email_sample_subject').html(),
            SHIPPING_SUBJECT = $('#email_shipping_subject').html(),
            SAMPLE_HTML = $($emailSampleBody).html(),
            SHIPPING_HTML = $($emailShippingeBody).html(),
            PRODUCT_TITLE = PRODUCT.title ? PRODUCT.title[I18n.locale] : '',
            EMAIL = 'hello@nutsandwoods.de';

    if (PRODUCT.title) {
        if ($emailSampleBody.length) {
            $emailSampleBody.html(SAMPLE_HTML
                .replace('%{PRODUCT}', PRODUCT_TITLE)
            );
            const mailtoLink = `mailto:${EMAIL}?subject=${encodeURIComponent(SAMPLE_SUBJECT)}&body=${encodeURIComponent($($emailSampleBody).html())}`;
            const sampleLink = document.getElementById('email_sample') as HTMLAnchorElement;
            sampleLink.href = mailtoLink;
        }
        if ($emailShippingeBody.length) {
            $emailShippingeBody.html(SHIPPING_HTML
                .replace('%{PRODUCT}', PRODUCT_TITLE)
            );
            const mailtoLink = `mailto:${EMAIL}?subject=${encodeURIComponent(SHIPPING_SUBJECT)}&body=${encodeURIComponent($($emailShippingeBody).html())}`;
            const shippingLink = document.getElementById('email_shipping') as HTMLAnchorElement;
            shippingLink.href = mailtoLink;
        }
    }
}
import accordionExpand from '../parts/accordion-expand';
accordionExpand();

const watcher = new Watcher();

// Intro Effekte triggern:
setTimeout(() => {
    $('.product-intro .emerge').addClass('emerge-show');
    $('.product-intro .intro-riseup').addClass('intro-riseup-show');
}, 100);

// $('.product-intro .intro-riseup .screen').on('transitionend', () => {
//     $('.product-intro .intro-riseup')[0].style.zIndex = '1';
// });

// Maskierung vom Intro-Bild
if (!isPhone) {
    const biggerCover = $('.product-intro .img-wrapper').hasClass('bigger-cover');
    const SPEED = 1;
    const startWidth = biggerCover ? 87.5 : 62.5; //%
    const startHeight = biggerCover ? 87.5 : 65.5; //%
    const widthDiv = 100 - startWidth; // % Breite soll auf 100% wachsen
    const heightDiv = 100 - startHeight; // % Höhe soll auf 100% wachsen
    watcher.add({
        // element: $('.product-info .spacer')[0],
        element: $('.product-intro .content')[0],
        onProgress: (element, {introShortProgress, outroProgress}) => {
            // const progress = outroProgress;
            const progress = introShortProgress;
            const mask = $('.product-intro .img-wrapper .mask')[0];
            const width = startWidth + widthDiv * Math.min(1, progress * SPEED); // %
            const height = startHeight + heightDiv * Math.min(1, progress * SPEED); // %

            mask.style.width = `${width}%`;
            mask.style.height = `${height}%`;
        },
    });
}

if (!isPhone) {
    const $images = $('.details-options .images .img-wrapper');

    const SPEED = 1;
    const startHeight = 75; //%
    const heightDiv = 100 - startHeight; // % Höhe soll auf 100% wachsen

    $images.each((index, ele) => {
        watcher.add({
            element: $(ele).find('figure')[0],
            onProgress: (element, {upperProgress}) => {
                const progress = upperProgress;
                const mask = $(ele).find('.mask')[0];
                const height = startHeight + heightDiv * Math.min(1, progress * SPEED); // %
                mask.style.height = `${height}%`;
            },
        });
    });
}

if (!isPhone) {
    new StickyGarage(watcher, $('.product-intro')[0], $('.product-info')[0], {reverseGarage: true});
    new StickyGarage(watcher, $('.details-options')[0], $('#product_details')[0], {reverseGarage: true});
    new StickyGarage(watcher, $('#product_details')[0], $('.hotspots-container')[0], {reverseGarage: true});
}

const testimonials = $('#testimonials')[0];
if (testimonials) {
    if(!isPhone) {
        new StickyGarage(watcher, $('.hotspots-container')[0], testimonials, {reverseGarage: true});
    } else {
        // new StickyGarage(watcher, $('#product_details')[0], testimonials, {reverseGarage: true});
    }
}

const $slider = $('.intro-slider .scroll-x');
if (!NO_ANIMATIONS && isPhone && $slider.length) {
    const SPEED = 0.02;
    let time = 0;
    let direction: -1 | 1 = 1;
    let position = 0;
    const cancel = () => {
        if(raf === false) return;
        stop();
        raf = false;
    };
    const move = (dx: number) => {
        // Man kann die Scroll-Position nicht glatt animieren, nur in ganzen Pixeln,
        // aber das ruckelt. Deswegen verschieben wir die Inhalte einzeln, setzen
        // sie bei Interaktion zurück und setzen stattdessen dann die echte Scrollposition.
        $slider.children().each(function() {
            this.style.transform = `translateX(${dx}px)`;
        });
    };
    const step = () => {
        raf = requestAnimationFrame(step);
        const now = Date.now();
        position += direction * (now - time) * SPEED;
        time = now;
        if(direction > 0) {
            const width = $slider[0].scrollWidth - $slider[0].offsetWidth;
            if(width <= 0) {
                // Sonderfall: Slideshow-Inhalt ist kleiner als der Bildschirm.
                cancel();
                return;
            }
            if(position > width) {
                position = width;
                direction *= -1;
            }
        } else {
            if(position < 0) {
                position = 0;
                direction *= -1;
            }
        }
        move(-position);
    };
    let raf: number | undefined | false;
    const start = (force: boolean) => {
        if(raf === false) {
            if(force)
                raf = undefined;
            else
                return;
        }
        if(raf) return;
        position = $slider[0].scrollLeft;
        $slider[0].scrollLeft = 0;
        time = Date.now();
        step();
    };
    const stop = () => {
        if(!raf) return;
        cancelAnimationFrame(raf);
        raf = undefined;
        $slider[0].scrollLeft = position;
        position = 0;
        move(-position);
    };
    watcher.add({
        element: $slider[0],
        onAppeared: () => start(false),
        onAppearing: () => start(true),
        onDisappeared: stop,
    });
    $slider.on('mousedown touchstart', () => cancel());
}

$('.product-details-section-new .emerge, .matching-slider .emerge, .product-faq .emerge.words').each((index, ele) => {
    watcher.add({
        element: ele,
        onAppearing(element, direction) {
            if (isPhone && $(element).parents('.accordion-expand').length) {
                if (!$('body').hasClass('show-more-details')) return;
            }
            const visible = $(element).hasClass('emerge-show');
            if(!visible)
                setTimeout(() => $(element).addClass('emerge-show'));
        },
        onDisappeared(element, direction) {
            if (direction == -1) {
                $(element).removeClass('emerge-show');
            }
        },
    });
});

$('#more-details-button').on('click', function(e) {
    $('body').addClass('show-more-details');
    $('.product-details-section-new .accordion-expand .emerge').addClass('emerge-show');
});
$('#faq-button').on('click', function(e) {
    $('body').addClass('show-faqs');
});
$('#more_testimonials').on('click', function(e) {
    $(this).addClass('show-more');
});


{
    const $images = $('section.new-scaling-layout .img-container');

    const SPEED = 1.2;
    const startWidth = 85; //%
    const startHeight = 85; //%
    const widthDiv = 100 - startWidth; // % Breite soll auf 100% wachsen
    const heightDiv = 100 - startHeight; // % Höhe soll auf 100% wachsen

    $images.each((index, ele) => {
        watcher.add({
            element: $(ele).find('figure')[0],
            onProgress: (element, {upperProgress}) => {
                const progress = upperProgress;
                const mask = $(ele).find('.mask')[0];
                const width = startWidth + widthDiv * Math.min(1, progress * SPEED); // %
                const height = startHeight + heightDiv * Math.min(1, progress * SPEED); // %

                mask.style.width = `${width}%`;
                mask.style.height = `${height}%`;
            },
        });
    });
}

$('section.new-scaling-layout .emerge:not(h1), .product-info .emerge').each((index, ele) => {
    watcher.add({
        element: ele,
        onAppearing(element, direction) {
            $(ele).addClass('emerge-show');
        },
        onDisappeared(element, direction) {
            if (direction == -1) {
                $(ele).removeClass('emerge-show');
            }
        },
    });
});

$<HTMLSelectElement>('#shipping-popup form select').on('change click', function() {
    const country = this.value;
    if(country)
        setCurrentCountry(country);
});

// Videos einfügen:
const $videos = $('video');

$videos.each((i, ele) => {
    const $video = $(ele) as JQuery<HTMLVideoElement>;
    if (!$video.length) return;
    new AutoplayVideo($video);
});
